import { useRouter } from "next/router";
import logger from "@airhelp/node-logger";
import { Schema } from "components/Schema";
import config from "config/config";
import getUrlFromLink from "utils/getUrlFromLink";
import createBreadcrumbsSchema from "utils/createBreadcrumbsSchema";
import type { BreadcrumbsSchemaProps } from "./BreadcrumbsSchema.d";

const BreadcrumbsSchema = ({
  breadcrumbsPositionName,
  breadcrumbsParentPage,
}: BreadcrumbsSchemaProps) => {
  const { asPath: pagePath, query: { language } } = useRouter();
  if (!breadcrumbsPositionName) return null;

  const { websiteUrl } = config;
  const currentUrl = `${websiteUrl}${pagePath}`;
  const firstElementUrl = `${websiteUrl}/${language}/`;
  const parentPositionName = breadcrumbsParentPage?.story?.content.breadcrumbsPositionName || "";
  const parentPageFullSlug = getUrlFromLink(breadcrumbsParentPage);
  const parentUrl = `${websiteUrl}${parentPageFullSlug}/`;

  if (parentPageFullSlug && !parentPositionName)
    logger.warn(`No breadcrumbs position name for assigned parent story "${parentUrl}" on "${currentUrl}".`);

  const breadcrumbs = createBreadcrumbsSchema(firstElementUrl, breadcrumbsPositionName, currentUrl, parentPositionName, parentUrl);

  return <Schema schema={breadcrumbs} />;
};

export default BreadcrumbsSchema;
